export default __webpack_public_path__ + "media/images/users/user-lawrence-sims-140x140-62450b7f962811183864c38acb242e96.jpg";